import { Text } from '@stitch-fix/mode-react';
import { G, S } from '@mobily/ts-belt';
import { useGetSearchResultsQuery, GetSearchResultsQueryVariables } from '../../utils/hooks/getSearchResults';
import { SearchParams, useSearchParams } from '../../utils/hooks/useSearchParams';
import { formatFiltersVariable } from '../../utils/helpers';
import ResultsPlaceholder from './ResultsPlaceholder';
import ResultsSuccess from './ResultsSuccess';
import ErrorMessage from '../ErrorMessage';
import NoResults from '../NoResults';
import { useResultsMachine } from '../../utils/machines/results/context-provider';
import ScrollToTop from '../ScrollToTop';
import { useCopy } from '../../utils/contexts/copy-provider';
import SiteNavigationBanner from './SiteNavigationBanner';
const formatQueryVariables = ({
  color = [],
  occasion = [],
  q = '',
  sort,
  page,
  autoSearch = false
}: SearchParams) => {
  const variables: GetSearchResultsQueryVariables = {
    q,
    page,
    limit: 59,
    autoSearch
  };
  const filters = formatFiltersVariable({
    color,
    occasion
  });
  if (G.isArray(filters)) {
    variables.filters = filters;
  }
  if (G.isString(sort) && S.isNotEmpty(sort)) {
    variables.sort = sort;
  }
  return variables;
};

/**
 * The `ResultsLayout` component handles state related to the initial load
 * as well as tying our state machine and `useQuery` hook together
 */
const ResultsLayout = () => {
  const {
    copy
  } = useCopy();
  const {
    state,
    send
  } = useResultsMachine();
  const {
    queryParams,
    reload
  } = useSearchParams();
  useGetSearchResultsQuery({
    variables: formatQueryVariables(queryParams),
    onError: e => send('REJECT', {
      error: e.message
    }),
    onCompleted: d => send('RESOLVE', {
      data: d.shopContent?.search
    })
  });
  return <>
      {(state.matches('success') || state.matches('empty')) && <SiteNavigationBanner search={state.context.data} />}

      {(state.matches('loading') || state.matches('success')) && <Text setting="title-medium" align={{
      sm: 'left',
      md: 'center'
    }} mb={0.5}>
          {copy.resultsForPrefix} &ldquo;{queryParams.q}&rdquo;
        </Text>}

      {state.matches('loading') && <ResultsPlaceholder />}

      {state.matches('success') && <ResultsSuccess search={state.context.data} />}

      {state.matches('failure') && <ErrorMessage hed="Unable to load this content" subhed={state.context.error} onClick={reload} />}

      {state.matches('empty') && <NoResults search={state.context.data} />}

      <ScrollToTop />
    </>;
};
export default ResultsLayout;